module.exports = __webpack_public_path__ + "static/media/Azure_firstPage_en.510aea8e.png";